import {
  PRE_START_RESPONSE_TYPES_V3,
  getFlagOptionsV3,
  responseConfigToResponseTypeValueV3,
  sanitizeResponseConfigForTypeV3
} from "../pre-start/preStartQuestionResponseConfigUtilsV3";

export const ANSWER_SCOPE_OPTIONS_V3 = [
  { value: "supervisor", label: "Supervisor" },
  { value: "worker", label: "Personal / Per Worker" }
];

export const FLAG_NONE_OPTION_V3 = { value: "", label: "None" };

export const RESPONSE_TYPE_OPTIONS_V3 = PRE_START_RESPONSE_TYPES_V3.map((typeOption) => ({
  value: typeOption.value,
  label: typeOption.label
}));

const getScopeOption = (scopeValue) => {
  return ANSWER_SCOPE_OPTIONS_V3.find((scopeOption) => scopeOption.value === scopeValue) || null;
};

const getResponseTypeOption = (responseTypeValue) => {
  return RESPONSE_TYPE_OPTIONS_V3.find((responseTypeOption) => responseTypeOption.value === responseTypeValue) || null;
};

export const getFlagOptionV3 = (responseTypeValue, flagOnValue) => {
  if (!flagOnValue) {
    return FLAG_NONE_OPTION_V3;
  }

  const matchedOption = getFlagOptionsV3(responseTypeValue).find((option) => option.value === flagOnValue);
  return matchedOption || FLAG_NONE_OPTION_V3;
};

export const getRescueReadinessQuestionInitialValuesV3 = ({ mode, selectedQuestion, emergencyPlanOptions }) => {
  if (mode === "edit" && selectedQuestion) {
    const responseType = responseConfigToResponseTypeValueV3(selectedQuestion.response_config);
    const normalizedType = responseType || "yes_no";
    const normalizedConfig = normalizedType
      ? sanitizeResponseConfigForTypeV3(normalizedType, selectedQuestion.response_config || {})
      : {};

    const selectedPlanId = selectedQuestion.emergency_plan_id !== undefined
      ? selectedQuestion.emergency_plan_id
      : selectedQuestion.plan_id;
    const emergencyPlanOption = Array.isArray(emergencyPlanOptions)
      ? emergencyPlanOptions.find((option) => selectedPlanId != null && `${option.value}` === `${selectedPlanId}`)
      : null;
    const copiedPlan = selectedQuestion.emergency_plan && typeof selectedQuestion.emergency_plan === "object"
      ? selectedQuestion.emergency_plan
      : null;
    const fallbackPlanId = copiedPlan && (copiedPlan.value !== undefined || copiedPlan.id !== undefined)
      ? (copiedPlan.value !== undefined ? copiedPlan.value : copiedPlan.id)
      : selectedPlanId;
    const fallbackPlanLabel = (copiedPlan && (copiedPlan.label || copiedPlan.title || copiedPlan.plan_name))
      || selectedQuestion.plan_name || selectedQuestion.emergency_plan_name || selectedQuestion.plan_title || "";
    const fallbackPlanOption = fallbackPlanId != null && fallbackPlanLabel
      ? { value: fallbackPlanId, label: fallbackPlanLabel }
      : null;

    return {
      question_text: selectedQuestion.question_text || "",
      guidance_text: selectedQuestion.guidance_text || "",
      answer_scope: getScopeOption(selectedQuestion.answer_scope || "supervisor"),
      required: Boolean(selectedQuestion.required),
      active: Boolean(selectedQuestion.active),
      response_type: getResponseTypeOption(normalizedType),
      response_config: normalizedConfig,
      flag_on_value: getFlagOptionV3(normalizedType, normalizedConfig.flagOnValue),
      unit: normalizedConfig.type === "number" && normalizedConfig.unit != null ? `${normalizedConfig.unit}` : "",
      emergency_plan: emergencyPlanOption || fallbackPlanOption || null
    };
  }

  return {
    question_text: "",
    guidance_text: "",
    answer_scope: null,
    required: true,
    active: true,
    response_type: null,
    response_config: {},
    flag_on_value: FLAG_NONE_OPTION_V3,
    unit: "",
    emergency_plan: null
  };
};

export const validateRescueReadinessQuestionV3 = (values = {}) => {
  const errors = {};
  const responseTypeValue = values.response_type && values.response_type.value ? values.response_type.value : "";
  const answerScopeValue = values.answer_scope && values.answer_scope.value ? values.answer_scope.value : "";
  const trimmedQuestionText = values.question_text ? values.question_text.trim() : "";
  const selectedEmergencyPlanValue = values.emergency_plan && Object.prototype.hasOwnProperty.call(values.emergency_plan, "value")
    ? values.emergency_plan.value
    : "";

  if (!trimmedQuestionText) {
    errors.question_text = "Question text is required.";
  }

  if (!PRE_START_RESPONSE_TYPES_V3.some((option) => option.value === responseTypeValue)) {
    errors.response_type = "Response type is required.";
  }

  if (!["supervisor", "worker"].includes(answerScopeValue)) {
    errors.answer_scope = "Answer scope is required.";
  }


  if (responseTypeValue) {
    const normalizedConfig = sanitizeResponseConfigForTypeV3(responseTypeValue, values.response_config || {});
    if (normalizedConfig.type === "radio") {
      const flagValue = values.flag_on_value && values.flag_on_value.value ? values.flag_on_value.value : "";
      if (flagValue) {
        const flagOptions = getFlagOptionsV3(responseTypeValue).map((option) => option.value);
        if (!flagOptions.includes(flagValue)) {
          errors.flag_on_value = "Flag value is invalid for the selected response type.";
        }
      }
    }
  }

  return errors;
};






